import React, { useEffect, useState } from "react";
import "../Dashboard/Dashboard.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { sassTrue } from "sass";
import { toast } from "react-toastify";
import Loader from "../../Loader/Loader";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";

const AllRooms = () => {
  const [loader, setLoader] = useState(false);
  const vendorToken = localStorage.getItem("token");

  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const { id } = useParams();

  const handleEdit = (room_id, rooms) => {
    navigate(`/partner/rooms/edit/${room_id}/${id}`, { state: { rooms } });
  };

  const openDeletePopup = (id) => {
    setSelectedId(id);
    setDeletePopup(true);
  };

  const closeDeletePopup = () => {
    setDeletePopup(false);
  };

  const { id: propertyId } = useParams();

  // const getRooms = (id) => {
  //   setLoader(true);
  //   const requestOptions = {
  //     // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
  //     headers: {
  //       "Content-Type": "application/json",
  //       key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/get-rooms/${id}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log("result", result);

  //       if (result.success) {
  //         setRooms(result?.rooms);
  //         setLoader(false);
  //       } else {
  //         setRooms([]);
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const getRooms = async (id) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rooms/list/${id}`,
        requestOptions
      );
      const result = await response.json();
      setRooms(result?.data);
      setLoader(false);

    } catch (error) {
      console.log(error.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (propertyId) {
      getRooms(propertyId);
    }
  }, [propertyId]);

  const fetchSingleRoom = (rommId) => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `https://extranet.travcatalyst.com/apiv1/vendor/get-single-room/${rommId}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        if (result.success) {
          getRooms(propertyId);
        } else {
        }
      })
      .catch((error) => console.error(error));
  };

  // const deleteRooms = () => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("key", process.env.REACT_APP_API_KEY);
  //   myHeaders.append("Content-Type", "application/json");

  //   const requestOptions = {
  //     method: "DELETE",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/delete-room/${selectedId}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.success) {
  //         setDeletePopup(false);
  //         getRooms(propertyId);
  //         toast.success(result.message);
  //       } else {
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  function handleDeleteRoom() {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      ids: selectedId,
    });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rooms/delete`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        if (result.success) {
          showSuccessToast(result.message);
          setDeletePopup(false);
          getRooms(id);
        } else {
          showErrorToast(result.message);
          setDeletePopup(false);
        }
      })
      .catch((error) => {
        console.error("Error deleting property:", error);
        setDeletePopup(false);
      });
  }

  return (
    <section className="mt-10 bg-white-div p_0">
      <div className="flex justify_content_between align_items_center p_10">
        <h4>Rooms</h4>
        <div className="flex flex_gap_10">
          <Link
            to={`/vendor/property/add-room/${id}`}
            className="vendor_common_property flex align_items_center"
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_7239_14229"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="17"
              >
                <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_7239_14229)">
                <path
                  d="M8 14.5C7.81111 14.5 7.65278 14.4361 7.525 14.3083C7.39722 14.1806 7.33333 14.0222 7.33333 13.8333V9.16667H2.66667C2.47778 9.16667 2.31944 9.10278 2.19167 8.975C2.06389 8.84722 2 8.68889 2 8.5C2 8.31111 2.06389 8.15278 2.19167 8.025C2.31944 7.89722 2.47778 7.83333 2.66667 7.83333H7.33333V3.16667C7.33333 2.97778 7.39722 2.81944 7.525 2.69167C7.65278 2.56389 7.81111 2.5 8 2.5C8.18889 2.5 8.34722 2.56389 8.475 2.69167C8.60278 2.81944 8.66667 2.97778 8.66667 3.16667V7.83333H13.3333C13.5222 7.83333 13.6806 7.89722 13.8083 8.025C13.9361 8.15278 14 8.31111 14 8.5C14 8.68889 13.9361 8.84722 13.8083 8.975C13.6806 9.10278 13.5222 9.16667 13.3333 9.16667H8.66667V13.8333C8.66667 14.0222 8.60278 14.1806 8.475 14.3083C8.34722 14.4361 8.18889 14.5 8 14.5Z"
                  fill=""
                />
              </g>
            </svg>
            Add
            {/* Add Room */}
          </Link>
        </div>
      </div>
      {loader ? (
        <Loader size="4em" color="#009A50" />
      ) : (
        <>
          {rooms?.length > 0 ? (
            <>
              {" "}
              <table
                className="inventory_table m_0" style={{ borderRadius: "15px" }}
              >
                <tr>
                  <th
                    style={{
                      background: "#F3F3F3",
                      color: "#666",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    {" "}
                    Name
                  </th>
                  <th
                    style={{
                      background: "#F3F3F3",
                      color: "#666",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  ></th>
                  <th
                    style={{
                      background: "#F3F3F3",
                      color: "#666",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  ></th>
                </tr>
                {rooms?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item?.name}</td>

                      <td>
                        <div className="flex justify_content_end flex_gap_10">
                          <span
                            style={{
                              padding: "2px 7px",
                              fontSize: "12px",
                              borderRadius: "4px",
                            }}
                            onClick={() =>
                              navigate(
                                `/vendor/property/all-rooms/rate-plans/${propertyId}/${item.id}`
                              )
                            }
                          >
                            Manage Rates
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="flex justify_content_end flex_gap_20">
                          {/* <span > */}
                          <svg
                            onClick={() => openDeletePopup([item?.id])}
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FE3500"
                          >
                            <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
                          </svg>
                          {/* </span> */}
                          {/* <span > */}
                          <svg
                            onClick={() => handleEdit(item?.id, item)}
                            width="25"
                            height="25"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_2797_7470"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="25"
                              height="25"
                            >
                              <rect width="20" height="20" fill="#009A50" />
                            </mask>
                            <g mask="url(#mask0_2797_7470)">
                              <path
                                d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                                fill="#009A50"
                              />
                            </g>
                          </svg>
                          {/* </span> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </>
          ) : (
            <>
              <NoDataFound />
            </>
          )}
        </>
      )}
      {deletePopup && (
        <div className="popup_backdrop">
          <div className="popup_section p_20">
            <div>
              <div className="flex justify_content_between">
                <h4>Are you sure to Delete.</h4>
                <svg
                  onClick={() => closeDeletePopup(false)}
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                  <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                </svg>
              </div>

              <button
                className="vendor_common_property mt-10 w-full"
                type="button"
                onClick={() => handleDeleteRoom()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AllRooms;
